<template>
  <div>
    <slots-head
        :item="item"
        :type="type"
        @saveNameEdit="(value, item) => saveNameEdit(value, item)"
        @deleteItem="(item) => deleteItem(item)"
    ></slots-head>
    <div :id="'inactive-device' + id" style="width:100%;overflow-y:auto;height:100%; padding: 0 8px;">
      <ml-table :columns="columns" :data-source="data" :scroll="{ x: 0, y: scrolllY }">
        <template slot="serialNo" slot-scope="text, record">
          <div style="cursor: pointer; color: rgb(69, 124, 190);" @click="()=>ViewMOre('go-machine', { customerName: record.customerName,  keyWord: text })">{{text}}</div>
        </template>
        <template slot="customerName" slot-scope="text">
          <div style="cursor: pointer; color: rgb(69, 124, 190);" @click="()=>ViewMOre('screening-customers-table', { keyWord: text })">{{text}}</div>
        </template>
        <template slot="assemblyState" slot-scope="text">
          <a-tag :color="statusMap[text].remark">{{statusMap[text].dictValue}}</a-tag>
        </template>
      </ml-table>
    </div>
  </div>
</template>

<script>
import mixin from './cardmixin.vue'
import { MachineServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import { DictServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
const dictApi = new DictServiceProxy()
const machineApi = new MachineServiceProxy()

export default {
  name: 'repeat-custom-device',
  mixins: [mixin],
  data() {
    return {
      data: [],
      statusMap : {},
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('page_ops_machine_machine_serialNo'),
          dataIndex: 'serialNo',
          scopedSlots: { customRender: 'serialNo' },
          width: 100
        },
        {
          title: this.$t('gateway_code'),
          dataIndex: 'gatewayCode',
          ellipsis: true,
          width: 260,
        },
        {
          title: this.$t('page_mdc_customer_name'),
          dataIndex: 'customerName',
          scopedSlots: { customRender: 'customerName' },
          width: 260
        },
        {
          title: this.$t('page_resource_pool_status'),
          dataIndex: 'assemblyState',
          width: 120,
          ellipsis: true,
          key: "assemblyState",
          scopedSlots: { customRender: 'assemblyState' },
        }
      ]
    }
  },
  mounted() {
    this.getMachineAssemblyState();
  },
  methods: {
    getMachineAssemblyState() {
      dictApi.dictionary('machine-assembly-state').then(res=>{
        console.log(res);
        res.data?.map(v=>{
          this.statusMap[v.dictKey] = v;
        });
        this.getList()
      })
    },
    async getList() {
      machineApi.getUnactivatedMachineList().then(data=>{
        this.data = data
        this.checkScrollY('inactive-device', this.data.length)
      })
    }
  }
}
</script>

<style></style>
